module.exports = __webpack_public_path__ + "img/SKMJ_submit2.5f618b1f.jpg";